import {Component, OnInit} from '@angular/core';
import {Topic} from "../../../domain/topic";
import {Router} from "@angular/router";

@Component({
    selector: 'app-post',
    templateUrl: './post.component.html',
    styleUrls: ['./post.component.scss']
})
export class PostComponent implements OnInit {

    constructor(private router: Router) {
    }

    ngOnInit() {
    }

    public refreshPosts( topic : Topic ){
        this.router.navigate(["home","post",topic.id]);
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/post/post.component.ts